// 暖通连接类型
export const HVAC_CONNECT_TYPE = {
    ROUND_DUCT_ELBOW: {
        label: "圆管弯头",
        value: 1,
    },
    ROUND_DUCT_TTEE: {
        label: "圆管T形三通",
        value: 2,
    },
    ROUND_DUCT_YTEE: {
        label: "圆管Y形三通",
        value: 3,
    },
    RECTANGULAR_DUCT_ELBOW: {
        label: "矩形管弯头",
        value: 4,
    },
    RECTANGULAR_DUCT_TTEE: {
        label: "矩形管T形三通",
        value: 5,
    },
}

export const HVAC_CONNECT = {
    ROUND_DUCT_ELBOW: 1,
    ROUND_DUCT_TTEE: 2,
    ROUND_DUCT_YTEE: 3,
    RECTANGULAR_DUCT_ELBOW: 4,
    RECTANGULAR_DUCT_TTEE: 5,
}

export const getConnectTypeName = (value) => {
    switch (value) {
        case HVAC_CONNECT.ROUND_DUCT_ELBOW:
            return '圆管弯头';
        case HVAC_CONNECT.ROUND_DUCT_TTEE:
            return '圆管T形三通';
        case HVAC_CONNECT.ROUND_DUCT_YTEE:
            return '圆管Y形三通';
        case HVAC_CONNECT.RECTANGULAR_DUCT_ELBOW:
            return '矩形管弯头';
        case HVAC_CONNECT.RECTANGULAR_DUCT_TTEE:
            return '矩形管T形三通';
    }
    return '';
}
